import React, { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { ShieldCheck, ArrowRight } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/context/I18nContext";
import { SEO } from "@/components/SEO";

export const AdminLogin = () => {
  const { t } = useI18n();
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [pwd, setPwd] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErr("");
    try {
      await login(email, pwd);
      nav("/admin");
    } catch (e) {
      const detail = e?.response?.data?.detail;
      setErr(typeof detail === "string" ? detail : "Login fehlgeschlagen");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-[80vh] flex items-center justify-center px-6 py-20 bg-soft">
      <SEO title="Admin Anmeldung" noindex />
      <div className="w-full max-w-md border border-line bg-white p-10 shadow-soft">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 bg-primary flex items-center justify-center"><ShieldCheck className="text-white" /></div>
          <div>
            <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-muted">IT-Servicepoint</div>
            <h1 className="font-display font-bold text-2xl text-ink">{t.admin.login_title}</h1>
          </div>
        </div>

        <form className="mt-8 space-y-5" onSubmit={submit}>
          <label className="block">
            <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-muted">{t.admin.email}</span>
            <input
              type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-login-email"
              className="mt-2 w-full bg-white border border-line px-4 py-3 focus:border-primary outline-none"
            />
          </label>
          <label className="block">
            <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-muted">{t.admin.password}</span>
            <input
              type="password" required value={pwd} onChange={(e) => setPwd(e.target.value)}
              data-testid="admin-login-password"
              className="mt-2 w-full bg-white border border-line px-4 py-3 focus:border-primary outline-none"
            />
          </label>
          {err && <div data-testid="admin-login-error" className="border border-red-300 bg-red-50 p-3 text-sm text-red-700">{err}</div>}
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full inline-flex items-center justify-center gap-2 px-6 py-3.5 bg-primary text-white font-medium hover:bg-primary-hover transition-colors disabled:opacity-50"
          >
            {loading ? t.common.loading : t.admin.sign_in} <ArrowRight size={18} />
          </button>
        </form>
      </div>
    </div>
  );
};
